import { Autocomplete, Box, TextField } from '@mui/material';
import { useMemo } from 'react';

const STATUS_OPTIONS = [
  { value: 'not_started', label: 'Not Started', color: '#9e9e9e' },
  { value: 'in_progress', label: 'In Progress', color: '#2196f3' },
  { value: 'drafted', label: 'Drafted', color: '#ff9800' },
  { value: 'revised', label: 'Revised', color: '#4caf50' },
  { value: 'complete', label: 'Complete', color: '#8bc34a' },
] as const;

interface StatusSelectProps {
  value: string | null | undefined;
  onChange: (status: string | null) => void;
  size?: 'small' | 'medium';
}

export function StatusSelect({
  value,
  onChange,
  size = 'small',
}: StatusSelectProps) {
  const sorted = useMemo(
    () =>
      [...STATUS_OPTIONS].sort((a, b) =>
        a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
      ),
    [],
  );

  const selected = sorted.find((o) => o.value === value) ?? null;

  return (
    <Autocomplete
      size={size}
      fullWidth
      options={sorted}
      getOptionLabel={(o) => o.label}
      value={selected}
      onChange={(_, newValue) => onChange(newValue?.value ?? null)}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: option.color,
              }}
            />
            {option.label}
          </Box>
        </li>
      )}
      renderInput={(params) => <TextField {...params} label="Status" />}
    />
  );
}

export { STATUS_OPTIONS };
